/**
 * planDisplayName — Anzeigename fuer eine rohe Plan-ID.
 *
 * Faellt ein Plan aus dem aktuellen Katalog (`GET /api/v2/subscription/plans`)
 * heraus — Alt-Tarife wie `premium`, oder der Demo-QA-Account —, hatten die
 * Badges bisher den rohen Enum-Wert angezeigt ("premium"). Diese Funktion ist
 * der einzige Fallback-Pfad: `enterprise_xl` -> "Enterprise XL".
 */
const UPPERCASE_PARTS = new Set(['x', 'xl', 'api', 'iot'])

export function planDisplayName(planId: string | null | undefined): string | null {
  if (!planId) return null
  return planId
    .split(/[_\s-]+/)
    .filter(Boolean)
    .map((part) =>
      UPPERCASE_PARTS.has(part.toLowerCase())
        ? part.toUpperCase()
        : part.charAt(0).toUpperCase() + part.slice(1),
    )
    .join(' ')
}
